import router from './router/index'
import store from './store/index'
import NProgress from 'nprogress'
import { ElNotification, ElMessageBox } from 'element-plus'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { getUserMenu } from "./api/jurisdiction";

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // 设置白名单
// 记录路由
let hasRoles = true
/**
 * 格式化后端返回的菜单结构
 * @param menu
 */
function initMenu(data) {
    let menuList
    let getMenus = localStorage.getItem('menuList')
    let getMenusJson = data
    let menuRole = [
        {
            name: "permission",
            path: "/permission",
            meta:{
                icon: "chat-square",
                title: "权限管理"
            },
            redirect: "noRedirect",
            children:[
                {
                    name: "personnel",
                    path: "personnel",
                    meta:{
                        icon: "chat-square",
                        title: "角色管理"
                    },
                },
                {
                    name: "permission",
                    path: "permission",
                    meta:{
                        icon: "chat-square",
                        title: "权限管理"
                    },
                }
            ]
        }
    ]
    let p = []
    for(let i = 0;i < getMenusJson.length;i++){
        if(getMenusJson[i].children.length === 0){
            p.push({
                name:getMenusJson[i].name,
                path:getMenusJson[i].path,
                component: () => import('@/layout/index.vue'),
                meta:{title:getMenusJson[i].title,icon:getMenusJson[i].icon},
                children:getMenusJson[i].children
            })
        }else{
            p.push({
                name:getMenusJson[i].name,
                path:getMenusJson[i].path,
                component: () => import('@/layout/index.vue'),
                meta:{title:getMenusJson[i].title,icon:getMenusJson[i].icon},
                children:getChildMenu(getMenusJson[i].children)
            })
        }

    }
    menuList = p
    return menuList
}
function getChildMenu(data){
    let p = []
    for(let i = 0;i < data.length;i++){
        console.log('com',data[i].component)
        if(data[i].children.length === 0){
            p.push({
                name:data[i].name,
                path:data[i].path,
                component: () => import(`./views${data[i].component}.vue`),
                meta:{title:data[i].title,icon:data[i].icon},
                children:data[i].children
            })
        }else{
            p.push({
                name:data[i].name,
                path:data[i].path,
                component: () => import(`./views${data[i].component}.vue`),
                meta:{title:data[i].title,icon:data[i].icon},
                children:getChildMenu(data[i].children)
            })
        }
    }
    return p
}
router.beforeEach(async(to, from, next) => {
  // 开启进度条
  NProgress.start()

  // set page title
  document.title = to.meta.title

  // 确定用户是否已登录
  const hasToken = getToken()
    try {
        // 路由添加进去了没有及时更新 需要重新进去一次拦截
        //next() // // 如果不传参数就会重新执行路由拦截，重新进到这里
        if (to.path !== '/login'){
            // const menuList =  await  getUserMenu()
            // localStorage.removeItem('menuList')
            // localStorage.setItem('menuList',JSON.stringify(menuList.data.menus))
        }
        if(!store.state.permission.routes.length){
            // 获取权限列表进行接口访问 因为这里页面要切换权限
            // const roles = await store.dispatch('user/getInfo')
            const accessRoutes = await store.dispatch('permission/generateRoutes', store.getters.roles)
            hasRoles = false
            //initMenu(menuList.data.menus).forEach(item => router.addRoute(item)) // 动态添加访问路由表
            accessRoutes.forEach(item => router.addRoute(item)) // 动态添加访问路由表
            next({ ...to, replace: true }) // // 这里相当于push到一个页面 不在进入路由拦截
        }else {
            next() // // 如果不传参数就会重新执行路由拦截，重新进到这里
        }
    } catch (error) {
        ElNotification.error({
            title: '请求超时请重新登陆',
            duration: 5000
        })
        next(`/login?redirect=${to.path}`)
    }
  // if (hasToken) {
  //   if (to.path === '/login') {
  //     // 如果已登录，请重定向到主页
  //     next({ path: '/' })
  //        NProgress.done()
  //   } else {
    //
  //   }
  // }else{
  //     if (whiteList.indexOf(to.path) !== -1) {
  //         next()
  //     } else {
  //         next(`/login?redirect=${to.path}`)
  //         NProgress.done()
  //     }
  // }
})

router.afterEach(() => {
  NProgress.done()
})
